import { getDoc, doc, updateDoc } from 'firebase/firestore';
import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { db } from '../firebase/firebaseConfig';
import AddContents from './add_contents';
import { showToast } from '../utils/toast';
import { IS_DEMO } from '../utils/config';

async function fetchPost(id) {
  const docRef = doc(db, 'posts', id);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    const res = docSnap.data();
    
    const data = {
      title: res.title,
      description: res.description,
      tab: res.type,
      category: res.category,
      status: res.paid,
      listImage: res.media.listImage,
      bannerImage: res.media.bannerImage,
      sectionImage: res.media.newSectionImage,
      bgVideo: res.media.bgVideo,
      audio: res.media.audio,
      pages: res.media.pages,
      video: res.media.video
    };
    return data;
  } else {
    
    throw Error('no document exists by such id');
  }
}

export default function EditContent() {
  const { id } = useParams();
  const [data, setData] = useState(undefined);
  useEffect(() => {
    fetchPost(id)
      .then((data) => {
        setData(data);
      })
      .catch((err) => {
        
      });
  }, [id]);

  const editContent = useCallback(
    async (content) => {
      // Demo constraint
      if (IS_DEMO) {
        return showToast({
          type: 'error',
          message: 'This is a demo version. You cannot edit content.'
        });
      }

      const docRef = doc(db, 'posts', id);
      try {
        await updateDoc(docRef, { ...content });
        return showToast({
          type: 'success',
          message: 'Successfully updated the post'
        });
      } catch (error) {
        return showToast({
          type: 'error',
          message: 'Could not update the post! Please check back later'
        });
      }
    },
    [id]
  );
  //Maybe a form skeleten here while the document is being fetched
  return data ? <AddContents formValues={data} onUpload={editContent} /> : null;
}
